export function getPayNowLink(selectedAccount: any | null) {
    if (!selectedAccount?.accountReference) {
        console.error("No account reference available");
        return;
    }

    const baseUrl = "https://pay.allpay.net/accent/reference/create/";
    const merchantId = "30030234";
    const schemeCode = "AFRE";
    const rentAccountNumber = encodeURIComponent(selectedAccount.accountReference);

    return `${baseUrl}?merchantId=${merchantId}&clientreference=${rentAccountNumber}&schemecode=${schemeCode}`;
}
